export default __webpack_public_path__ + "static/luxer-one-author-98a152a31e81c6cdd879258f638799e3.png";